import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import {
  showAttachmentDialog,
  hideAttachmentDialog,
} from '../store/actions/attachmentDialog.actions';

export const useAttachmentDialog = () => {
  const dispatch = useDispatch();
  const savedResult = useSelector((state) => state.attachmentDialog.savedResult);
  const dialogs = useSelector((state) => state.attachmentDialog.dialogs);
  const pendingRequests = useRef(new Map());

  useEffect(() => {
    if (!savedResult) return;
    const onSaved = pendingRequests.current.get(savedResult.requestId);
    pendingRequests.current.delete(savedResult.requestId);
    onSaved?.(savedResult.attachment);
  }, [savedResult]);

  useEffect(() => {
    const activeRequests = new Set(dialogs.map((dialog) => dialog.requestId));
    pendingRequests.current.forEach((_, requestId) => {
      if (!activeRequests.has(requestId)) pendingRequests.current.delete(requestId);
    });
  }, [dialogs]);

  const openAttachmentDialog = useCallback(
    (options = {}) => {
      const { onSaved, ...dialogOptions } = options;
      const requestId = uuid();
      pendingRequests.current.set(requestId, onSaved);
      dispatch(showAttachmentDialog({ ...dialogOptions, requestId }));
      return requestId;
    },
    [dispatch]
  );

  const closeAttachmentDialog = useCallback(
    (requestId) => {
      pendingRequests.current.delete(requestId);
      dispatch(hideAttachmentDialog(requestId));
    },
    [dispatch]
  );
  return { openAttachmentDialog, closeAttachmentDialog };
};
